(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emerson-product-details"] && !Shopify.designMode) return;
  try {
    

  const initializeEmersonProductDetails = (section) => {

    if (section.dataset.emersonInitialized === 'true') return;



    const dataElement = section.querySelector('[data-emerson-variant-dimensions]');
  const featureDataElement = section.querySelector('[data-emerson-variant-features]');
  if (!dataElement && !featureDataElement) return;
  section.dataset.emersonInitialized = 'true';
  const variants = dataElement ? JSON.parse(dataElement.textContent).variants : [];
  const featureVariants = featureDataElement ? JSON.parse(featureDataElement.textContent).variants : [];
  const updateDimensions = (variantId) => {
    if (!variantId) return;
    const variant = variants.find((item) => String(item.id).split('/').pop() === String(variantId));
    if (variant) {
      ['size', 'width', 'depth', 'height'].forEach((key) => {
        const valueElement = section.querySelector(`[data-emerson-dimension="${key}"]`);
        const rowElement = section.querySelector(`[data-emerson-dimension-row="${key}"]`);
        if (!valueElement || !rowElement) return;
        valueElement.innerHTML = variant[key] || '';
        rowElement.hidden = !variant[key];
      });
      const overallValue = section.querySelector('[data-emerson-dimension="overall"]');
      if (overallValue) {
        const parseDimension = (html) => {
          const node = document.createElement('div');
          node.innerHTML = html || '';
          return node.textContent.trim();
        };
        const width = parseDimension(variant.width);
        const depth = parseDimension(variant.depth);
        if (width && depth) overallValue.textContent = `${width} × ${depth} (L-shaped configuration)`;
      }
    }
    const featureVariant = featureVariants.find((item) => String(item.id).split('/').pop() === String(variantId));
    const list = section.querySelector('[data-emerson-mechanism-list]');
    const panel = section.querySelector('[data-emerson-mechanism-panel]');
    if (list && panel && featureVariant) {
      const items = (featureVariant.features || '').split(';').map(item => item.trim()).filter(Boolean);
      list.replaceChildren();
      items.forEach(item => {
        const li = document.createElement('li');
        li.textContent = item;
        list.appendChild(li);
      });
      panel.hidden = items.length === 0;
    }
  };
  const syncFromProductForm = () => {

      const hotReloadElements = Array.from(document.querySelectorAll('product-hot-reload[data-variant-id]'));

      const hotReload = hotReloadElements.find((element) => element.querySelector('form[action\*="/cart/add"]')) || hotReloadElements[0];

      const variantInput = document.querySelector('form[action\*="/cart/add"] [name="id"]');

      const urlVariant = new URL(window.location.href).searchParams.get('variant');

      updateDimensions((hotReload && hotReload.dataset.variantId) || (variantInput && variantInput.value) || urlVariant);

    };



    const hotReloadElements = document.querySelectorAll('product-hot-reload[data-variant-id]');

    hotReloadElements.forEach((hotReload) => {

      const observer = new MutationObserver((mutations) => {

        const variantChanged = mutations.some((mutation) => mutation.attributeName === 'data-variant-id');

        if (variantChanged) updateDimensions(hotReload.dataset.variantId);

      });

      observer.observe(hotReload, { attributes: true, attributeFilter: ['data-variant-id'] });

    });



    document.addEventListener('change', () => window.setTimeout(syncFromProductForm, 50));

    document.addEventListener('variant:change', (event) => {

      const variantId = event.detail && event.detail.variant && event.detail.variant.id;

      window.setTimeout(() => variantId ? updateDimensions(variantId) : syncFromProductForm(), 0);

    });

    window.addEventListener('popstate', syncFromProductForm);

    syncFromProductForm();

  };



  document.querySelectorAll('[data-emerson-product-details]').forEach(initializeEmersonProductDetails);

  document.addEventListener('shopify:section:load', (event) => {

    event.target.querySelectorAll('[data-emerson-product-details]').forEach(initializeEmersonProductDetails);

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:request', async (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      return; 
    }

    // Cancel default cart addition processing
    event.preventDefault();

    try {
      // Convert FormData to array format (expected by AddToCartFlyout)
      const formData = event.detail.form;
      const formDataArray = [];
      for (let [key, value] of formData.entries()) {
        formDataArray.push({ name: key, value: value });
      }

      const submitButton = document.querySelector('button[type="submit"], input[type="submit"]');
      
        const addToCartFlyout = new window.AddToCartFlyout(formDataArray, {
          atcButton: submitButton,
          settings: {
            moneyFormat: window.SHOP_MONEY_FORMAT
          }
        });

        // Wait for AddToCartFlyout completion and return actual response data
        const handleComplete = (completeEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.resolve(completeEvent.detail.responseData);
        };

        const handleError = (errorEvent) => {
          document.removeEventListener('addToCartFlyout:complete', handleComplete);
          document.removeEventListener('addToCartFlyout:error', handleError);
          event.detail.reject(errorEvent.detail.error);
        };

        document.addEventListener('addToCartFlyout:complete', handleComplete);
        document.addEventListener('addToCartFlyout:error', handleError);

    } catch (error) {
      console.error('AddToCartFlyout error:', error);
      event.detail.reject(error);
    }
  });

  document.addEventListener('product-form:cart:navigate', (event) => {
    if (!window.CART_REDIRECTION_ENABLED) {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', (event) => {
    if (window.CART_REDIRECTION_ENABLED) {
      window.location.href = window.Theme.routes.cart_url;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mattress-landing-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-em-mattress-section]').forEach(function(section){
    section.querySelectorAll('[data-em-directions]').forEach(function(link){link.addEventListener('click',function(){if(window.gtag){window.gtag('event','get_directions_click',{event_category:'Store Visit Intent',event_label:link.textContent.trim()});}});});
    section.querySelectorAll('[data-em-phone]').forEach(function(link){link.addEventListener('click',function(){if(window.gtag){window.gtag('event','phone_call_click',{event_category:'Contact',event_label:'Mattress Landing Page'});}});});
    section.querySelectorAll('[data-em-model]').forEach(function(link){link.addEventListener('click',function(){if(window.gtag){window.gtag('event','mattress_model_click',{event_category:'Product Interest',event_label:link.closest('.em-mattress__model').querySelector('h3').textContent.trim()});}});});
  });

  } catch(e) { console.error(e); }
})();
})();
